var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15C17.2733 15 19.4535 14.2098 21.0609 12.8033C22.6684 11.3968 23.5714 9.48912 23.5714 7.5C23.5714 5.51088 22.6684 3.60322 21.0609 2.1967C19.4535 0.790176 17.2733 0 15 0C12.7267 0 10.5465 0.790176 8.93908 2.1967C7.33163 3.60322 6.42857 5.51088 6.42857 7.5C6.42857 9.48912 7.33163 11.3968 8.93908 12.8033C10.5465 14.2098 12.7267 15 15 15ZM11.9397 17.8125C5.34375 17.8125 0 22.4883 0 28.2598C0 29.2207 0.890625 30 1.98884 30H28.0112C29.1094 30 30 29.2207 30 28.2598C30 22.4883 24.6562 17.8125 18.0603 17.8125H11.9397Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactos);
export default __webpack_public_path__ + "static/media/Contactos.25b3d54a7f39d85b04e5ce5335637217.svg";
export { ForwardRef as ReactComponent };